export enum CHART_TYPE {
  EVENT = 'event',
  LINE = 'line',
  STATE = 'state',
}
